/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OptimizationRequest } from './OptimizationRequest';
import {
    OptimizationRequestFromJSON,
    OptimizationRequestFromJSONTyped,
    OptimizationRequestToJSON,
} from './OptimizationRequest';

/**
 * 
 * @export
 * @interface OptimizationMeta
 */
export interface OptimizationMeta {
    /**
     * 
     * @type {string}
     * @memberof OptimizationMeta
     */
    tradeDate: string;
    /**
     * 
     * @type {number}
     * @memberof OptimizationMeta
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof OptimizationMeta
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizationMeta
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizationMeta
     */
    startTimeEst: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizationMeta
     */
    completionTimeEst?: string;
    /**
     * 
     * @type {number}
     * @memberof OptimizationMeta
     */
    totalSeconds?: number;
    /**
     * 
     * @type {OptimizationRequest}
     * @memberof OptimizationMeta
     */
    optimizationRequest?: OptimizationRequest;
}

/**
 * Check if a given object implements the OptimizationMeta interface.
 */
export function instanceOfOptimizationMeta(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "owner" in value;
    isInstance = isInstance && "startTimeEst" in value;

    return isInstance;
}

export function OptimizationMetaFromJSON(json: any): OptimizationMeta {
    return OptimizationMetaFromJSONTyped(json, false);
}

export function OptimizationMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizationMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'optimizationId': json['optimization_id'],
        'owner': json['owner'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'startTimeEst': json['start_time_est'],
        'completionTimeEst': !exists(json, 'completion_time_est') ? undefined : json['completion_time_est'],
        'totalSeconds': !exists(json, 'total_seconds') ? undefined : json['total_seconds'],
        'optimizationRequest': !exists(json, 'optimization_request') ? undefined : OptimizationRequestFromJSON(json['optimization_request']),
    };
}

export function OptimizationMetaToJSON(value?: OptimizationMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'optimization_id': value.optimizationId,
        'owner': value.owner,
        'details': value.details,
        'start_time_est': value.startTimeEst,
        'completion_time_est': value.completionTimeEst,
        'total_seconds': value.totalSeconds,
        'optimization_request': OptimizationRequestToJSON(value.optimizationRequest),
    };
}

